import type { ISeries } from '../interfaces/ISeries';
import type { IGame } from '../interfaces/IGame';
import type { ITeam } from '../interfaces/ITeam';

export class Series implements ISeries {
  games: KnockoutObservableArray<KnockoutObservable<IGame>>;
  seriesDecided: KnockoutComputed<boolean>;
  seriesWinner: KnockoutComputed<KnockoutObservable<ITeam>>;
  seriesLoser: KnockoutComputed<KnockoutObservable<ITeam>>;
  isPlayoffGame: KnockoutObservable<boolean>;
  gamesToWin: number;

  constructor(games: Array<KnockoutObservable<IGame>>) {
    this.games = ko.observableArray(games);
    this.gamesToWin = Math.ceil(this.games().length / 2);
    // Fix: always initialize isPlayoffGame (NBA/NHL had it uninitialized)
    this.isPlayoffGame = ko.observable(false);

    this.seriesDecided = ko.computed(() => {
      let seriesHomeWins = 0;
      let seriesAwayWins = 0;

      if (this.games && this.games() && this.games()[0] && this.games()[0]()) {
        const seriesHomeTeam = this.games()[0]().home;
        const seriesAwayTeam = this.games()[0]().away;

        ko.utils.arrayForEach(this.games(), (game) => {
          if (game() && game().TeamThatWon()) {
            if (game().TeamThatWon() === seriesHomeTeam) {
              seriesHomeWins++;
            } else if (game().TeamThatWon() === seriesAwayTeam) {
              seriesAwayWins++;
            }
          }
        });
      }
      return seriesHomeWins >= this.gamesToWin || seriesAwayWins >= this.gamesToWin;
    });

    this.seriesWinner = ko.computed(() => {
      let seriesHomeWins = 0;
      let seriesAwayWins = 0;

      if (this.games && this.games() && this.games()[0] && this.games()[0]()) {
        const seriesHomeTeam = this.games()[0]().home;
        const seriesAwayTeam = this.games()[0]().away;

        ko.utils.arrayForEach(this.games(), (game) => {
          if (game() && game().TeamThatWon()) {
            if (game().TeamThatWon() === seriesHomeTeam) {
              seriesHomeWins++;
            } else if (game().TeamThatWon() === seriesAwayTeam) {
              seriesAwayWins++;
            }
          }
        });

        if (seriesHomeWins >= this.gamesToWin) {
          return this.games()[0]().home;
        } else if (seriesAwayWins >= this.gamesToWin) {
          return this.games()[0]().away;
        }
      }

      return null;
    });

    this.seriesLoser = ko.computed(() => {
      if (this.games && this.games() && this.games()[0] && this.games()[0]()) {
        const seriesHomeTeam = this.games()[0]().home;
        const seriesAwayTeam = this.games()[0]().away;
        return this.seriesWinner() === seriesHomeTeam ? seriesAwayTeam : seriesHomeTeam;
      }

      return null;
    });
  }

  getScoreFor(team: KnockoutObservable<ITeam>): number {
    let wins = 0;

    if (this.games && this.games() && this.games()[0] && this.games()[0]()) {
      ko.utils.arrayForEach(this.games(), (game) => {
        if (game() && game().TeamThatWon()) {
          if (game().TeamThatWon() === team) {
            wins++;
          }
        }
      });
      return wins;
    }

    return 0;
  }

  /** Returns the KO observable for the game at 0-based index, or undefined if out of bounds. */
  gameAt(idx: number): KnockoutObservable<IGame> | undefined {
    return this.games()[idx];
  }

  reset(): void {
    for (const gameObs of this.games()) {
      const game = gameObs();
      game.selectionType(0 as never);
      game.selectionMade(false);
      game.teamSelected('NONE');
    }
  }
}
